import { useColorModeValue } from "@chakra-ui/react";

export interface SignUpStyles {
  textColor: string;
  textColorBrand: string;
  googleBg: string;
  googleText: string;
  googleHover: { bg: string };
  googleActive: { bg: string };
  buttonBg: string;
}

export function useSignUpStyles(authStyles: any): SignUpStyles {
  const defaultTextColor = useColorModeValue("navy.700", "white");
  const defaultTextColorBrand = useColorModeValue("gray.300", "white");
  const defaultGoogleBg = useColorModeValue("white", "white");
  const defaultGoogleText = useColorModeValue("navy.700", "white");

  return {
    textColor: authStyles.colors?.textColor || defaultTextColor,
    textColorBrand: authStyles.colors?.textColorBrand || defaultTextColorBrand,
    googleBg: authStyles.colors?.googleBg || defaultGoogleBg,
    googleText: authStyles.colors?.googleText || defaultGoogleText,
    googleHover: useColorModeValue({ bg: "gray.200" }, { bg: "whiteAlpha.300" }),
    googleActive: useColorModeValue({ bg: "secondaryGray.300" }, { bg: "whiteAlpha.200" }),
    buttonBg: authStyles.colors?.buttonBg || "blue.500",
  };
}
